import { render, staticRenderFns } from "./RelatorioLogLotacao.vue?vue&type=template&id=7503ac96"
import script from "./RelatorioLogLotacao.vue?vue&type=script&lang=js"
export * from "./RelatorioLogLotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports